<template>
  <v-row>
    <v-col cols="3">
      <date-picker
        label="Transaction Date"
        v-model="data.transactionDate"
      ></date-picker>
    </v-col>
    <v-col cols="3">
      <v-text-field
        :rules="[
          value => !!value || 'Required',
          value => /^[0-9]*[.]*[0-9]*$/.test(value) || 'Invalid Amount'
        ]"
        label="Amount"
        placeholder="114.00"
        v-model="data.amount"
      ></v-text-field>
    </v-col>

    <v-col cols="3">
      <v-text-field
        label="Approval Number"
        v-model="data.approvalNo"
      ></v-text-field>
    </v-col>

    <v-col cols="3">
      <v-select
        label="Payment Method"
        v-model="data.payment_method"
        :items="['CREDIT CARD', 'DIRECT DEBIT', 'ONLINE PAYMENT', 'CASH']"
      ></v-select>
    </v-col>

    <v-col cols="4">
      <v-switch v-model="data.first" label="first"></v-switch>
    </v-col>
    <v-col cols="4">
      <v-switch v-model="data.last" label="last"></v-switch>
    </v-col>
    <v-col cols="4">
      <v-switch v-model="data.paid" label="paid"></v-switch>
    </v-col>

    <v-col v-if="status !== 'update'" cols="6">
      <v-select
        clearable
        label="Repeat transaction"
        v-model="data.repeat_transaction"
        :items="['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']"
      ></v-select>
    </v-col>
    <v-col v-if="status !== 'update'" cols="6">
      <v-select
        clearable
        label="Gap Duration"
        v-model="data.gap_duration"
        :items="['1 MONTH', '3 MONTHS', '4 MONTHS', '6 MONTHS', '12 MONTHS']"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import DatePicker from '../../../../components/DatePicker'
export default {
  name: 'TransactionForm',
  props: {
    data: Object,
    status: {
      default: 'create'
    }
  },
  components: {
    DatePicker
  }
}
</script>

<style scoped></style>
